import * as React from 'react';
import { MdClose } from 'react-icons/md';
import { Flex, H6, Button } from "./..";
import { useTheme } from "../../hooks";
import { getPaletteText } from "../../utils/paletteConversions";
export var DialogHeader = function (_a) {
    var children = _a.children, onClose = _a.onClose, _b = _a.palette, palette = _b === void 0 ? 'primary' : _b;
    var theme = useTheme();
    var bgColor = (theme === null || theme === void 0 ? void 0 : theme.template) === 'CINT' && palette === 'secondary'
        ? 'secondary700'
        : palette;
    return (React.createElement(Flex, { lss: {
            justifyContent: 'space-between',
            borderTopLeftRadius: 'md',
            borderTopRightRadius: 'md',
            flexShrink: 0,
            bg: bgColor
        } },
        React.createElement(H6, { as: "h1", lss: {
                ml: 'xl',
                my: 'lg',
                color: getPaletteText(palette)
            } }, children),
        onClose && (React.createElement(Button, { type: "button", onClick: onClose, emphasis: "high", lss: {
                bg: 'inherit',
                color: getPaletteText(palette),
                border: 'none',
                borderRadius: 'none',
                borderTopRightRadius: 'md'
            } },
            React.createElement(MdClose, { size: 18, color: "inherit" })))));
};
//# sourceMappingURL=DialogHeader.js.map